// src/lib/time/new-id.ts
/**
 * A random v4 UUID made in the browser for a new entry's id, so a retry after "may have
 * saved" hits the primary key instead of making a copy. `crypto.randomUUID` needs a secure
 * context; `getRandomValues` works everywhere.
 */
export function newId(): string {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40;
  bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
